import { useMutation, gql } from '@apollo/client';
import {
  CadastrarDisciplinaMutation,
  CadastrarDisciplinaMutationVariables,
} from './__generated__/CadastrarDisciplinaMutation';

const CADASTRAR_DISCIPLINA_MUTATION = gql`
  mutation CadastrarDisciplinaMutation(
    $dsc_nome_disciplina: String!
    $dsc_sigla: String!
    $dsc_ementa: String
    $num_carga_horaria: Int!
  ) {
    cadastrarDisciplina(
      input: {
        dsc_nome_disciplina: $dsc_nome_disciplina
        dsc_sigla: $dsc_sigla
        dsc_ementa: $dsc_ementa
        num_carga_horaria: $num_carga_horaria
      }
    ) {
      id_disciplina
      dsc_nome_disciplina
      dsc_sigla
      dsc_ementa
      num_carga_horaria
    }
  }
`;

const useCadastrarDisciplinaMutation = () => {
  return useMutation<CadastrarDisciplinaMutation, CadastrarDisciplinaMutationVariables>(
    CADASTRAR_DISCIPLINA_MUTATION
  );
};

export { useCadastrarDisciplinaMutation };
